import { useTranslation } from 'react-i18next';

import { useCutlistParts } from '@/api/store';

type Props = {
  customerReference: string;
  notes: string;
  deliverLeftoverMaterials: boolean;
};

export const CutlistNotesRecap = ({
  customerReference,
  notes,
  deliverLeftoverMaterials,
}: Props) => {
  const { t } = useTranslation();
  const parts = useCutlistParts();

  const isBeamsOnlyCutlist =
    parts.length > 0 && parts.every((p) => p.partType === 'beam');

  return (
    <div>
      {' '}
      {customerReference && (
        <>
          <p>
            <strong>{t('review.customerReference.title')}</strong>
          </p>
          <p>{customerReference}</p>
        </>
      )}
      {notes && (
        <>
          <p>
            <strong>{t('review.notes.title')}</strong>
          </p>
          <p>{notes}</p>
        </>
      )}
      {!isBeamsOnlyCutlist && (
        <>
          <p>
            <strong>{t('review.leftoverMaterials.title')}</strong>
          </p>
          <p>
            {t(
              `review.${
                deliverLeftoverMaterials
                  ? 'leftoverMaterials'
                  : 'noLeftoverMaterials'
              }.body`
            )}
          </p>
        </>
      )}
    </div>
  );
};
